import { Component, createSignal, Show } from "solid-js";

export type AvatarSize = "xs" | "sm" | "md" | "lg";

export interface AvatarProps {
  name: string;
  src?: string;
  size?: AvatarSize;
  class?: string;
}

const sizeClasses: Record<AvatarSize, string> = {
  xs: "w-5 h-5 text-[9px]",
  sm: "w-8 h-8 text-xs",
  md: "w-10 h-10 text-sm",
  lg: "w-12 h-12 text-base",
};

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const Avatar: Component<AvatarProps> = (props) => {
  const [imageLoaded, setImageLoaded] = createSignal(false);
  const [imageError, setImageError] = createSignal(false);

  const initials = () => getInitials(props.name);
  const showImage = () => props.src && imageLoaded() && !imageError();
  const sizeClass = sizeClasses[props.size ?? "md"];

  return (
    <div
      class={
        "relative inline-flex items-center justify-center rounded-full overflow-hidden border border-line " +
        sizeClass +
        " " +
        (props.class ?? "")
      }
    >
      <Show when={!showImage()}>
        <div class="w-full h-full flex items-center justify-center bg-sunken text-ink-2 font-medium">
          {initials()}
        </div>
      </Show>
      <Show when={props.src}>
        <img
          src={props.src}
          alt={props.name}
          class="absolute inset-0 w-full h-full object-cover"
          classList={{ "opacity-0": !showImage() }}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
        />
      </Show>
    </div>
  );
};
